import React from 'react'
import ReactDOM from 'react-dom/client'
import AuthenticatedAppState, {
  SessionAppState,
} from './features/auth/components/AuthenticatedAppState'
import { ClerkProvider } from '@clerk/clerk-react'
import './styling/index.css'
import '@fontsource-variable/inter'
import '@fontsource-variable/inter/wght-italic.css'
import '@fontsource-variable/jetbrains-mono'
import { APP_NAME } from './constants'
import App from './App'
import Loading from '@features/shared/components/Loading'
import { env } from './config/env'
import { installStaleChunkReload } from '@features/shared/utils/staleChunkReload'

installStaleChunkReload()

const localWorktreeName = import.meta.env.DEV ? import.meta.env.VITE_LOCAL_WORKTREE_NAME : ''
document.title = localWorktreeName ? `${APP_NAME} | ${localWorktreeName}` : APP_NAME

const clerkPubKey = env.VITE_CLERK_PUBLISHABLE_KEY

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {clerkPubKey ? (
      <ClerkProvider
        publishableKey={clerkPubKey}
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/"
        signUpFallbackRedirectUrl="/"
      >
        <AuthenticatedAppState loadingFallback={<Loading />}>
          <App />
        </AuthenticatedAppState>
      </ClerkProvider>
    ) : (
      <SessionAppState identity="development" loadingFallback={<Loading />}>
        <App />
      </SessionAppState>
    )}
  </React.StrictMode>
)
